export default "__VITE_ASSET__DWUbOVuC__"